import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "freightsetting",
    staticStyle: {
      width: "100%",
      display: "flex",
      "flex-direction": "column"
    }
  }, [_c("a-card", {
    staticStyle: {
      "margin-top": "24px",
      flex: "1"
    },
    attrs: {
      bordered: false
    }
  }, [_vm.deliveryChannel == 1 ? _c("a-tabs", {
    attrs: {
      "tab-position": "top",
      animated: false
    },
    on: {
      change: _vm.changeSendWay
    },
    model: {
      value: _vm.activeKeyForSendWayList,
      callback: function callback($$v) {
        _vm.activeKeyForSendWayList = $$v;
      },
      expression: "activeKeyForSendWayList"
    }
  }, _vm._l(_vm.sendWayList, function (pane, key2) {
    return _c("a-tab-pane", {
      key: pane.id,
      attrs: {
        tab: pane.name,
        disabled: _vm.editingKey !== ""
      }
    });
  }), 1) : _vm._e(), _c("a-table", {
    attrs: {
      columns: _vm.columns,
      loading: _vm.isTableLoading,
      "data-source": _vm.tableDataList,
      bordered: "",
      pagination: false,
      rowKey: "id"
    },
    scopedSlots: _vm._u([{
      key: "regionName",
      fn: function fn(text, record) {
        return _c("span", {}, [_vm._v(" " + _vm._s(text) + " "), record.addressList && record.addressList.length > 0 ? _c("a-tooltip", [_c("template", {
          slot: "title"
        }, _vm._l(record.addressList, function (one, i) {
          return _c("span", [_vm._v(" " + _vm._s(one.addressName) + " "), i % 2 == 1 ? _c("span", [_c("br")]) : _vm._e()]);
        }), 0), _c("a-icon", {
          staticStyle: {
            "margin-left": "4px"
          },
          attrs: {
            type: "info-circle"
          }
        })], 2) : _vm._e()], 1);
      }
    }, {
      key: "status",
      fn: function fn(text, record) {
        return _c("span", {}, [text == 1 ? [_c("a-tag", {
          attrs: {
            color: "blue"
          }
        }, [_vm._v(_vm._s(_vm.$t("public.enable")))])] : [_c("a-tag", {
          attrs: {
            color: "red"
          }
        }, [_vm._v(_vm._s(_vm.$t("public.disable")))])]], 2);
      }
    }, {
      key: "transportDay",
      fn: function fn(text, record) {
        return _c("span", {}, [record.editable ? _c("div", [_c("a-input-number", {
          staticStyle: {
            "text-align": "right"
          },
          attrs: {
            min: 0,
            max: 365,
            "allow-clear": ""
          },
          model: {
            value: _vm.cacheData.transportDay,
            callback: function callback($$v) {
              _vm.$set(_vm.cacheData, "transportDay", $$v);
            },
            expression: "cacheData.transportDay"
          }
        })], 1) : [_c("div", [_vm._v(_vm._s(text))])]], 2);
      }
    }, {
      key: "operation",
      fn: function fn(text, record, index) {
        return [_c("div", {
          staticClass: "editable-row-operations"
        }, [record.editable ? _c("span", [_c("a", {
          on: {
            click: function click() {
              return _vm.save(record.id);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("freightsetting.save")))]), _c("a-divider", {
          attrs: {
            type: "vertical"
          }
        }), _c("a", {
          on: {
            click: function click($event) {
              return _vm.cancel(record.id);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("public.cancel")))])], 1) : _c("span", [_c("a", {
          attrs: {
            disabled: _vm.editingKey !== ""
          },
          on: {
            click: function click() {
              return _vm.edit(record.id);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("public.edit")))]), _c("a-divider", {
          attrs: {
            type: "vertical"
          }
        }), record.status == "1" ? _c("a-popconfirm", {
          attrs: {
            placement: "topRight",
            title: _vm.$t("public.sureStop"),
            "ok-text": _vm.$t("publicuse.determine"),
            "cancel-text": _vm.$t("public.cancel")
          },
          on: {
            confirm: function confirm($event) {
              return _vm.confirmGengXin(record, 0);
            }
          }
        }, [_c("a", {
          attrs: {
            disabled: _vm.editingKey !== ""
          }
        }, [_vm._v(_vm._s(_vm.$t("public.disable")))])]) : _vm._e(), record.status == "0" ? _c("a-popconfirm", {
          attrs: {
            placement: "topRight",
            title: _vm.$t("public.sureEnable"),
            "ok-text": _vm.$t("publicuse.determine"),
            "cancel-text": _vm.$t("public.cancel")
          },
          on: {
            confirm: function confirm($event) {
              return _vm.confirmGengXin(record, 1);
            }
          }
        }, [_c("a", {
          attrs: {
            disabled: _vm.editingKey !== ""
          }
        }, [_vm._v(_vm._s(_vm.$t("public.enable")))])]) : _vm._e()], 1)])];
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };